module.exports = __webpack_public_path__ + "static/img/ikonaPrezentacjaDisabled-ON.78ea3fec.png";